import { actionsForConversionType } from './customEventConversions';

export const MAX_GOALS = 3;

const generateGoalId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `goal-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
};

export const newGoal = (overrides = {}) => ({
  id: generateGoalId(),
  name: '',
  actions: [],
  trackRevenue: false,
  ...overrides,
});

export const defaultCampaignGoals = (domain) => [
  newGoal({
    name: 'Purchases',
    trackRevenue: true,
    actions: actionsForConversionType(domain?.customEventConversions, 'Purchase'),
  }),
];

// Handles campaigns saved under the legacy `goal: {...}` shape so the form
// always sees `goals: [...]`. Also assigns a stable client-side id to each
// goal so React keys remain stable across reorder/remove operations.
export const normalizeCampaignGoals = (campaign) => {
  if (!campaign) return campaign;
  let goals = campaign.goals;
  if (!Array.isArray(goals) || goals.length === 0) {
    goals = campaign.goal ? [campaign.goal] : [];
  }
  goals = goals.map((g) => ({ ...g, id: g.id || generateGoalId() }));
  return { ...campaign, goals };
};
